<template>
  <nav id="top" class="navbar topnav">
    <div class="navbar-brand" style="padding: 5px; height: 80px; align-items: center;">
      <router-link to="/">
        <img src="@/assets/lp/logo_blue.svg" href="/" alt="HRモンスター">
      </router-link>
      <span v-if="isShowMenu()" class="navbar-burger burger" data-target="navbarMenuHeroA" :class="{ 'is-active': menuActive }" v-on:click="menuToggle()" style="background: #1B2C61; color: white;">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </div>
    <div v-if="isShowMenu()" id="navbarMenuHeroA" class="navbar-menu" v-bind:class="{ 'is-active': menuActive }" style="padding: 0;">
      <div class="navbar-end">
        <!-- <a class="navbar-item hover-item" href="#hrmonster" v-smooth-scroll>
          TOP
        </a> -->
        <a class="navbar-item hover-item" href="#because" v-smooth-scroll>
          機能
        </a>
        <!-- <a class="navbar-item hover-item" href="#case" v-smooth-scroll>
          事例
        </a> -->
        <router-link class="navbar-item hover-item" to="/companydemo">
          特徴/設置イメージ
        </router-link>
        <router-link class="navbar-item hover-item" to="/inquiry?select=資料請求したい">
          資料請求
        </router-link>
        <router-link class="navbar-item hover-item" to="/login">
          ログイン
        </router-link>
        <!-- <router-link class="navbar-item inquiry hover-item" to="/create_client">
          <p><span class="mdi mdi-email-outline mdi-24px"></span></p>
          <p style="margin-top: -5px;">無料登録</p>
        </router-link> -->
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TopNav',
  componentName: 'TopNav',
  components: {
  },
  props: {
    height: {
      type: String,
      default: '0px'
    },
    ismenu: true
  },
  mounted () {
    console.debug('*** Start *** mounted')
    console.log('LANGUAGE: ' + window.navigator.language)
    // var lang = window.navigator.language
    // if (lang.indexOf('en') !== -1) {
    //   lang = 'en'
    // } else {
    //   lang = 'ja'
    // }
    setTimeout(() => {this.handleClick_changeLanguage('ja')}, 2000)
    console.debug('*** End *** mounted')
  },
  data () {
    return {
      menuActive: false,
      showModal: false
    }
  },
  methods: {
    menuToggle () {
      console.debug('*** Start *** menuToggle')
      this.menuActive = !this.menuActive
      console.debug('*** End *** menuToggle')
    },
    handleClick_changeLanguage (lang) {
      console.debug('*** Start *** handleClick_changeLanguage')
      console.debug('lang: ' + JSON.stringify(lang))
      this.$i18n.locale = lang
      console.debug('*** End *** handleClick_changeLanguage')
    },
    isShowMenu() {
      return this.ismenu;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.signup {
  font-weight: 900;
}
.topnav{
  font-size: 16px;
  background: #f8f8f8;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.hover-item:hover {
  color: white;
  background: rgba(50, 50, 100, 0.7);
}
.hover-item {
  color: black;
  font-weight: 600;
  padding: 10px 20px;
}
.inquiry {
  padding-right: 30px;
  padding-left: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #1B2C61;
  color:white;
}
img{
  height: 70px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Top/TopNav.vue